module.exports = __webpack_public_path__ + "img/m_mw.305e6e91.png";